import React from 'react';

export const nameComponent = <T = {}>(name: string, Component: React.FC<T>): React.FC<T> => {
  Component.displayName = Component.displayName ? `${Component.displayName}.${name}` : name;
  return Component;
};
